<template>
  <div class="w-full">
    <div v-if="!loading" class="flex gap-2 h-full">
      <div class="flex-1">
        <VueSelect
          :class="{
            'placeholder-selected': placeholderIsSelected,
            textColor,
          }"
          :title="placeholder"
          @update:model-value="onInput"
          :options="!isAsyncSearching ? (Array.isArray(formattedOptions) ? formattedOptions : []) : []"
          :selectLabel="'Druk op enter'"
          :deselectLabel="'Druk op enter'"
          :selectedLabel="'geselecteerd'"
          :placeholder="placeholder"
          label="Label"
          track-by="Id"
          :disabled="disabled"
          @search-change="onSearch"
        />
      </div>
      <div class="flex-vertical-center flex-initial" v-if="isAsyncSearching">
        <font-awesome-icon :spin="true" :icon="['far', 'spinner']" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VueSelect from "vue-select";
import { computed, ref, watch } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { SelectOption } from "@planbord/shared/models";

const emit = defineEmits<{
  (e: "update:modelValue", value: unknown): void;
  (e: "onSearch", value: string): void;
}>();

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    error?: string;
    hideError?: boolean;
    placeholder?: string;
    modelValue: unknown;
    options: SelectOption[];
    optionLabel?: string;
    disabled?: boolean;
    placeholderIsSelected?: boolean;
    asyncSearch?: boolean;
    isSearching?: boolean;
    textColor?: string;
  }>(),
  {
    loading: false,
    hideError: false,
    disabled: false,
    placeholderIsSelected: false,
  }
);

const isAsyncSearching = ref(false);

function onSearch(value: string) {
  if (!props.asyncSearch) {
    return;
  }

  isAsyncSearching.value = true;
  emit("onSearch", value);
}

watch(
  () => props.options,
  () => {
    if (isAsyncSearching.value) {
      isAsyncSearching.value = false;
    }
  }
);

const formattedOptions = computed(() =>
  props.options.map((option) => ({
    Id: option.Id,
    Label: option.Label,
  }))
);

function onInput(value: SelectOption) {
  emit("update:modelValue", value.Id);
}
</script>

<style>
#person input,
#person input:focus {
  @apply text-neutral-1000 !important;
  @apply text-lg font-normal !important;
  @apply p-0 m-0 !important;
  @apply whitespace-nowrap !important;
  @apply overflow-hidden !important;
  @apply w-4/5 !important;
}

#person input::placeholder {
  @apply text-xl !important;
}

#vehicle .vs__selected,
#vehicle input,
#vehicle input::placeholder {
  @apply text-5xl p-0 m-0 opacity-100 !important;
}

#vehicle .vs__selected {
  @apply flex h-0 flex-col !important;
}
#vehicle .vs__selected-options {
  @apply pt-2 pl-2 !important;
}
#vehicle.oost .vs__selected-options {
  padding-top: 12px !important;
}

.vs__dropdown-toggle {
  @apply p-0 !important;
}

.select-placeholder-white-override .vs__selected,
.select-placeholder-white-override input::placeholder {
  @apply text-neutral-0 !important;
  @apply min-w-[75px] !important;
}

.select-placeholder-black-override .vs__selected,
.select-placeholder-black-override input::placeholder {
  @apply min-w-[75px] !important;
  @apply text-neutral-1000 !important;
}

.vs__dropdown-menu {
  @apply text-neutral-1000 !important;
}
</style>
